import { render } from "./HeaderFooterDesigner.vue?vue&type=template&id=7dcefbe7&scoped=true"
import script from "./HeaderFooterDesigner.vue?vue&type=script&lang=js"
export * from "./HeaderFooterDesigner.vue?vue&type=script&lang=js"

import "./HeaderFooterDesigner.vue?vue&type=style&index=0&id=7dcefbe7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7dcefbe7"]])

export default __exports__